export const indexes = { street: 0, house: 1, room: 2 };
